const state = () => ({
    info: {},
    userInfo: {},
    current: 0,
    totalCount: 1,
    isAgree: true,
    toastVisible: false,
    showInfo: true,
    qrcodeImg: '',
    showInfoImg: '',
    hideInfoImg: '',
    movieList: [],
    finalList: [],
    pageNo: 0,
    height: 667,
    h5Width: 375,
    h5Height: 667,
    defaultImg: 'this.src="https://i0.hdslb.com/bfs/activity-plat/static/d1cf92bc9dbcd4aba66a240199ecc790/default_img.jpg"',
});
export default state;
